import React, { useState } from 'react';
import styles from './styles';

const FileInput = ({ label, field, accept = "image/*,application/pdf", onFileChange, preview, onPreview }) => {
  console.log(`📦 FileInput mounted for field: ${field}`);

  const [fileName, setFileName] = useState("");

  const handleChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    console.log(`📂 User selected file for ${field}:`, selected.name);

    const allowedTypes = accept.split(',');
    if (!allowedTypes.some(type => selected.type.includes(type.replace('*', '')))) {
      console.warn(`⚠️ Invalid file type for ${field}:`, selected.type);
      return;
    }

    setFileName(selected.name);
    onFileChange(field, selected);
  };

  return (
    <div style={styles.inputGroup}>
      <label>{label}:</label>
      <input type="file" accept={accept} onChange={handleChange} />
      {fileName && <span style={styles.fileName}>📎 {fileName}</span>}
      {!fileName && preview?.url && (
        <button
          type="button"
          style={styles.previewButton}
          onClick={() => onPreview(preview.url, preview.mimeType)}
        >
          🔍 Preview
        </button>
      )}
    </div>
  );
};

export default FileInput;